export function getAuthUser() {
  const raw = localStorage.getItem("atcUser");
  return raw ? JSON.parse(raw) : null;
}

export function getAuthToken() {
  return localStorage.getItem("atcToken");
}

export function setAuthSession(data) {
  localStorage.setItem("atcToken", data.token);
  localStorage.setItem("atcUser", JSON.stringify({
    email: data.email,
    role: data.role,
    is_admin: data.is_admin
  }));
}

export function clearAuthSession() {
  localStorage.removeItem("atcToken");
  localStorage.removeItem("atcUser");
}

export function apiUrl(url) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  if (!baseUrl) return url;
  return `${baseUrl}${url.replace(/^\/api/, "")}`;
}

export function apiFetch(url, options = {}) {
  const token = getAuthToken();
  const headers = {
    ...(options.headers || {})
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(apiUrl(url), {
    ...options,
    headers
  }).then(res => {
    if (res.status === 401) {
      clearAuthSession();
      window.location.href = "/";
    }

    return res;
  });
}

export function parseBackendDate(value) {
  if (!value) return null;
  const raw = String(value);
  const hasTimezone = /[zZ]|[+-]\d\d:?\d\d$/.test(raw);
  return new Date(hasTimezone ? raw : `${raw}Z`);
}

export function formatLagosDateTime(value) {
  const date = parseBackendDate(value);
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-GB", {
    timeZone: "Africa/Lagos",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
}

export function formatLagosDate(value) {
  const date = parseBackendDate(value);
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    timeZone: "Africa/Lagos",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
}

export function formatDateOnly(value) {
  if (!value) return "";
  const raw = String(value);
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) return `${match[3]}/${match[2]}/${match[1]}`;
  return raw;
}

export function parseDateOnly(value) {
  const raw = String(value || "").trim();
  const match = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (match) return `${match[3]}-${match[2]}-${match[1]}`;
  return raw;
}
